var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-pill badge-light",class:_vm.className,on:{"click":_vm.changePriority}},[_c('i',{staticClass:"zmdi zmdi-alert-circle",class:_vm.priorityColor})])}
var staticRenderFns = []

export { render, staticRenderFns }